export const bodyMotion = {
  initial: { height: 0 },
  animate: { height: 'auto' },
  exit: { height: 0 },
  transition: {
    type: 'tween',
  },
};
